import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dataDownloaderWorker from "../../workers/dataDownloaderWorker";
import WebWorker from "../../workers/WebWorker";
import { getCurrencySymbol } from "../../utils/Utils";
import { integraTecXTPStrings } from "../../constants/integraTecXTPStrings";

const createCleaningAdvisorExcelSheet = (
  workbook,
  sheetData,
  columns,
  sheetName,
  t,
  transposeData = false
) => {
  const excelSheet = workbook.addWorksheet(sheetName);
  let messages = [];
  if (sheetData) {
    if (transposeData) {
      if (columns.length === sheetData.length) {
        for (let i = 0; i < columns.length; i++) {
          const row = excelSheet.addRow([columns[i], sheetData[i]]);
          row.getCell(1).font = { bold: true };
          row.getCell(2).alignment = { horizontal: "right" };
        }
        excelSheet.getColumn(1).width = 50;
      }
    } else {
      excelSheet.getRow(1).font = { bold: true };
      excelSheet.columns = Object.keys(columns).map((key) => ({
        key,
        header: columns[key],
        width: 20,
      }));
      excelSheet.addRows(sheetData);
    }

    if (sheetName === t("excelSheetNames.cleaningEffectivness")) {
      let greaterThan100MessageAdded = false;
      let lessThan0MessageAdded = false;
      // let containsAsteriskMessageAdded = false;
      // let datapresentmessage = false;
      // let superscriptAMessageAdded = false;
      // let superscriptBMessageAdded = false;

      sheetData.forEach((row) => {
        [
          "effectiveness",
          "avg_ceb_effectiveness",
          "avg_backwash_effectiveness",
        ].forEach((colKey) => {
          const cellValue = row[colKey];
          // if (!datapresentmessage && String(cellValue)) {
          //   messages.push(` ${t("cleaningEffectivnessStrings.note")}`);
          //   datapresentmessage = true;
          // }
          if (
            !greaterThan100MessageAdded &&
            String(cellValue).includes("> 100")
          ) {
            messages.push(
              ` ${t("cleaningEffectivnessStrings.noteForValuesrGeaterThan100")}`
            );
            greaterThan100MessageAdded = true;
          }
          if (!lessThan0MessageAdded && String(cellValue).includes("< 0")) {
            messages.push(
              ` ${t("cleaningEffectivnessStrings.noteForValuesLessThan0")}`
            );
            lessThan0MessageAdded = true;
          }
          // if (!containsAsteriskMessageAdded && String(cellValue).includes("*")) {
          //   messages.push(`${t("cleaningEffectivnessStrings.noteWith*")}`);
          //   containsAsteriskMessageAdded = true;
          // }
          // if (!superscriptAMessageAdded && String(cellValue).includes("ᵃ")) {
          //   messages.push(
          //     `${t("cleaningEffectivnessStrings.notewithsuperscripta")}`
          //   );
          //   superscriptAMessageAdded = true;
          // }
          // if (!superscriptBMessageAdded && String(cellValue).includes("ᵇ")) {
          //   messages.push(
          //     `${t("cleaningEffectivnessStrings.notewithsuperscriptb")}`
          //   );
          //   superscriptBMessageAdded = true;
          // }
        });
      });
      if (messages.length > 0) {
        excelSheet.addRow();
        excelSheet.addRow();
        messages.forEach((msg) => {
          excelSheet.addRow([msg]).font = { bold: true };
        });
      }
    }
    if (sheetName === t("excelSheetNames.others")) {
      const dividerRow1 = excelSheet.insertRow(56);
      const dividerRow = excelSheet.insertRow(57);
      const dividerRow2 = excelSheet.insertRow(58);
      dividerRow.height = 30;
      const dividerCell = dividerRow.getCell("A");
      dividerCell.value = t("analyseData.settings");
      dividerCell.font = { bold: true, size: 14 };
      dividerRow.border = {
        top: { style: "medium", color: { argb: "FFD3D3D3" } },
        bottom: { style: "medium", color: { argb: "FFD3D3D3" } },
      };
    }
  }
};

const createCleaningAdvisorPredictExcelSheet = (
  workbook,
  sheetName,
  dataSets,
  messages,
  t
) => {
  const excelSheet = workbook.addWorksheet(sheetName);
  let currentRow = 1;
  const columnStyle = {
    fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFFF" } },
    font: { color: { argb: "000000" } },
    border: {
      top: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    },
  };

  dataSets?.forEach((dataSet, dataSetIndex) => {
    if (dataSet && dataSet.length > 0) {
      const message = messages[dataSetIndex] || "";
      const startCol = 0;
      const endCol = startCol + dataSet[0]?.length - 1;

      if (message) {
        excelSheet.addRow();
        excelSheet.addRow();
        excelSheet.addRow([message], { font: { bold: true } });
        currentRow++;
      }
      excelSheet.addTable({
        name: `Table_${dataSetIndex + 1}`,
        ref: `${String.fromCharCode(
          65 + startCol
        )}${currentRow}:${String.fromCharCode(65 + endCol)}${
          currentRow + dataSet.length - 1
        }`,
        columns: Object.keys(dataSet[0])?.map((col, colIndex) => {
          let columnName = t(`PredictAndRecommendStrings.${col}`);

          let uniqueName = columnName;
          if (
            col.includes("recommend") &&
            columnName ===
              t(
                `PredictAndRecommendStrings.${col.replace(
                  "recommend",
                  "predict"
                )}`
              )
          ) {
            uniqueName = columnName + "_Recommend";
          }
          return {
            name: uniqueName,
            style: columnStyle,
          };
        }),
        rows: dataSet.map((row) => Object.values(row)),
      });
      excelSheet.properties.defaultColWidth = 20;
      excelSheet.properties.showGridLines = true;
      currentRow += dataSet.length + 3;
    }
  });

  // Add disclaimer text at the bottom
  excelSheet.addRow();
  excelSheet.addRow();
  excelSheet.addRow([
    t("integraTecXTP.disclaimerText"),
  ]);
};

const transposeData = (data) => {
  const transposedData = Object.keys(data[0])
    .map((key) => data.map((row) => row[key]))
    .flat();

  return transposedData;
};

const transposeColumns = (columns, otherSheetData, t) => {
  const temperature = otherSheetData[0]["temperature"];
  const volume = otherSheetData[0]["volume"];
  const currency = otherSheetData[0]["currency"];
  const mass = otherSheetData[0]["mass"];
  const pressure = otherSheetData[0]["pressure"];
  const flow = otherSheetData[0]["flow"];
  return Object.keys(columns).map((key) => {
    let columnValue = columns[key].replace("$", getCurrencySymbol[currency]);
    if (columnValue.includes(t("OthersTableStrings.cipWaterPrice"))) {
      columnValue = columnValue.replace("<unit>", volume);
    } else if (
      columnValue.includes(t("OthersTableStrings.cipAcidPrice")) ||
      columnValue.includes(t("OthersTableStrings.cipAlkaliPrice")) ||
      columnValue.includes(t("OthersTableStrings.additional_chemical_price")) ||
      columnValue.includes(t("OthersTableStrings.cebAcidPrice")) ||
      columnValue.includes(t("OthersTableStrings.cebAlkaliPrice")) ||
      columnValue.includes(
        t("OthersTableStrings.ceb_additional_chemical_price")
      ) ||
      columnValue.includes(t("OthersTableStrings.acid_used_per_ceb")) ||
      columnValue.includes(t("OthersTableStrings.alkali_used_per_ceb")) ||
      columnValue.includes(t("OthersTableStrings.acid_used_per_cip")) ||
      columnValue.includes(t("OthersTableStrings.alkali_used_per_cip"))
    ) {
      columnValue = columnValue.replace("<unit>", mass);
    } else if (
      columnValue.includes(t("OthersTableStrings.norm_tmp_threshold")) ||
      columnValue.includes(t("OthersTableStrings.norm_tmp_threshold_cip"))
    ) {
      columnValue = columnValue.replace("<unit>", pressure);
    } else if (
      columnValue.includes(t("OthersTableStrings.filtrate_flow_threshold"))
    ) {
      columnValue = columnValue.replace("<unit>", flow);
    } else {
      columnValue = columnValue.replace("<unit>", temperature);
    }
    return columnValue;
  });
};

const saveExcelFile = async (exportAllSheetName, workbook) => {
  const fileName = exportAllSheetName;
  const buffer = await workbook.xlsx.writeBuffer();
  const excelData = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(excelData, fileName);
};

export const exportAllTables = async (
  exportAllSheetName,
  exportData,
  foulingType,
  t
) => {
  const worker = new WebWorker(dataDownloaderWorker);

  const translations = {
    exportWorkerTransaltionString: t("exportWorkerTransaltionString", {
      returnObjects: true,
    }),
  };
  worker.postMessage({ exportData, translations, foulingType });
  worker.onerror = (error) => console.log("Error in Worker:", error);
  worker.onmessage = (event) => {
    const {
      userCips,
      predicitionSheetData,
      benefitSheetDataMessage,
      benefitSheetData,
      annualBenefitSheetDataMessage,
      annualBenefitSheetData,
      cipSheetData,
      cleaningEffectinessSheetData,
      foulingSheetData,
      otherSheetData,
      backwashSheetData,
    } = event.data;

    const workbook = new ExcelJS.Workbook();

    const messages = [
      "",
      benefitSheetDataMessage,
      annualBenefitSheetDataMessage,
    ];
    createCleaningAdvisorPredictExcelSheet(
      workbook,
      t("excelSheetNames.predict"),
      [predicitionSheetData, benefitSheetData, annualBenefitSheetData],
      messages,
      t
    );
    const temperature = otherSheetData[0]["temperature"];
    const mass = otherSheetData[0]["mass"];
    const HistoricCipTableStringsObj = t("HistoricCipTableStrings", {
      returnObjects: true,
    });
    Object.values(HistoricCipTableStringsObj).forEach((value, index) => {
      if (value.indexOf("<unit>") > -1) {
        if (
          value.includes(t("HistoricCipTableStrings.acidUsed")) ||
          value.includes(t("HistoricCipTableStrings.alkaliUsed")) ||
          value.includes(t("HistoricCipTableStrings.solutionUsed"))
        ) {
          HistoricCipTableStringsObj[
            Object.keys(HistoricCipTableStringsObj)[index]
          ] = value.replace("<unit>", mass);
        } else {
          HistoricCipTableStringsObj[
            Object.keys(HistoricCipTableStringsObj)[index]
          ] = value.replace("<unit>", temperature);
        }
      }
    });
    // Combine cipSheetData and backwashSheetData with a 5-row gap for the historicalCIPS sheet
    const cleaningsCount = cipSheetData ? cipSheetData.length : 0;
    const backwashSheetDataWithIndex = (backwashSheetData || []).map(
      (row, i) => ({
        ...row,
        index: cleaningsCount + i + 1,
      })
    );
    const combinedCipBackwashSheetData = [
      ...(cipSheetData || []),
      ...Array(5).fill({}), // 5 empty rows as gap
      ...backwashSheetDataWithIndex,
    ];
    createCleaningAdvisorExcelSheet(
      workbook,
      combinedCipBackwashSheetData,
      HistoricCipTableStringsObj,
      t("excelSheetNames.historicalCIPS"),
      t
    );
    const HistoricalCIPEffectivnessTableStringsObj = t(
      "HistoricalCIPEffectivnessTableStrings",
      { returnObjects: true }
    );
    createCleaningAdvisorExcelSheet(
      workbook,
      cleaningEffectinessSheetData,
      HistoricalCIPEffectivnessTableStringsObj,
      t("excelSheetNames.cleaningEffectivness"),
      t
    );
    // const FoulingTableStringsObj = t("FoulingTableStrings", {
    //   returnObjects: true,
    // });
    // createCleaningAdvisorExcelSheet(
    //   workbook,
    //   foulingSheetData,
    //   FoulingTableStringsObj,
    //   t("excelSheetNames.fouling"),
    //   t
    // );

    const OthersTableStringsObj = t("OthersTableStrings", {
      returnObjects: true,
    });
    const transposedOtherSheetData = transposeData(otherSheetData);
    const transposedOtherSheetColumn = transposeColumns(
      OthersTableStringsObj,
      otherSheetData,
      t
    );

    createCleaningAdvisorExcelSheet(
      workbook,
      transposedOtherSheetData,
      transposedOtherSheetColumn,
      t("excelSheetNames.others"),
      t,
      true
    );

    saveExcelFile(exportAllSheetName, workbook);
    worker.terminate();
  };
};

export default exportAllTables;
